import { ExternalLink } from "lucide-react";

export default function NewsCard({ item, testid }) {
    return (
        <a href={item.url} target="_blank" rel="noreferrer nofollow"
            className="surface surface-hover p-5 flex flex-col gap-3 group" data-testid={testid}>
            <div className="flex justify-between items-center text-[10px] uppercase tracking-[0.24em]">
                <span className="text-[#d4af37]">{item.category}</span>
                <span className="text-white/40">{item.source_name}</span>
            </div>
            <div className="font-display text-lg md:text-xl leading-snug text-white group-hover:text-[#d4af37] transition-colors">
                {item.title}
            </div>
            {item.excerpt && <div className="text-white/55 text-xs leading-relaxed line-clamp-3">{item.excerpt}</div>}
            <div className="mt-auto flex justify-between items-end text-xs pt-3 border-t border-white/10">
                <span className="text-white/40">{item.published_at ? new Date(item.published_at).toLocaleDateString() : ""}</span>
                <span className="text-white/50 flex items-center gap-1 group-hover:text-[#d4af37]">Read <ExternalLink size={11} /></span>
            </div>
        </a>
    );
}
